import { render, staticRenderFns } from "./LevyPayment.vue?vue&type=template&id=4664438d&"
import script from "./LevyPayment.vue?vue&type=script&lang=js&"
export * from "./LevyPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports